define('Store.Facets.Translator', [
    'Facets.Translator',
    'Profile.Model',
    'Store.Collection',
    'underscore'
], function StoreFacetsTranslator(
    FacetsTranslator,
    ProfileModel,
    StoreCollection,
    _
) {
    'use strict';

    _.extend(FacetsTranslator.prototype, {
        parseUrlFacet: function parseUrlFacet(name, value) {
            // Gets the config for the current facet
            var profile = ProfileModel.getInstance();
            var store = profile.get('store');
            var config = this.getFacetConfig(name, 'id');
            var wrongStoreId = config.storeId && config.storeId + '' !== store.get('internalid') + '';
            var stores = StoreCollection.getInstance();
            var wrongStore = wrongStoreId && stores.get(config.storeId);
            var facetsValues;
            var newUrl;
            var self = this;

            if (config.id === 'commercecategoryname' || config.id === 'category' || !name) {
                return;
            }

            if (wrongStoreId && wrongStore && wrongStore.get('priceField') &&
                config.id === wrongStore.get('priceField').toLowerCase() && store && store.get('priceField')) {
                this.parseUrlFacet(store.get('priceField').toLowerCase(), value);
                newUrl = this.getUrl();
                Backbone.history.navigate(newUrl, { trigger: false });
                return true;
            } else if (wrongStoreId) {
                newUrl = this.getUrl();
                Backbone.history.navigate(newUrl, { trigger: false });
                return null;
            }

            facetsValues =
                value && value.split(this.configuration.facetDelimiters.betweenDifferentFacetsValues);

            facetsValues = _.map(facetsValues, function(val) {
                val = decodeURIComponent(val);
                val = self.encodeComponent(val);

                return val;
            });

            this.facets.push({
                config: config,
                id: config.id,
                url: config.id,
                value: this.sanitizeValue(
                    facetsValues.join(this.configuration.facetDelimiters.betweenDifferentFacetsValues),
                    config.behavior
                ),
                isParameter: config.isParameter
            });
        }
    });
});
